const J = {
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete",
  RESPONSE_STATUS: "responseStatus",
  ERROR: "error",
  AVAILABLE: "available",
  ARCHIVE: "archive",
  UNARCHIVE: "unarchive",
  URGENT: "urgent",
  NOT_URGENT: "not Urgent",
  AUTOMATION: "automation",
  CANCEL: "cancel"
};
var I = /* @__PURE__ */ ((r) => (r.MIN_0 = "0 Minutes", r.MIN_5 = "5 Minutes", r.MIN_10 = "10 Minutes", r.MIN_15 = "15 Minutes", r.MIN_30 = "30 Minutes", r.MIN_45 = "45 Minutes", r.HOUR_1 = "1 Hour", r.HOUR_1_2 = "1.5 Hours", r.HOUR_2 = "2 Hours", r.HOUR_3 = "3 Hours", r.HOUR_4 = "4 Hours", r.HOUR_5 = "5 Hours", r.HOUR_6 = "6 Hours", r.HOUR_7 = "7 Hours", r.HOUR_8 = "8 Hours", r.HOUR_9 = "9 Hours", r.HOUR_10 = "10 Hours", r.HOUR_11 = "11 Hours", r.HOUR_12 = "12 Hours", r.DAY_1 = "1 Day", r.DAY_2 = "2 Days", r))(I || {}), N = /* @__PURE__ */ ((r) => (r.ACCEPTED = "Accepts Invite", r.DECLINED = "Declines Invite", r.TENTATIVE = "Tentatively Accepts", r))(N || {}), t = /* @__PURE__ */ ((r) => (r.BEFORE_INTERVIEW = "Before Each Interview", r.AFTER_INTERVIEW = "After Each Interview", r.BEFORE_SESSION = "Before All Interviews", r.AFTER_SESSION = "After All Interviews", r.AWAIT_RESPONSE_INTERVIEWER = "Await Response - Interviewer", r.AWAIT_RESPONSE_CANDIDATE = "Await Response - Candidate", r.AWAIT_AVAILABILITY_CANDIDATE = "Await Availability - Candidate", r.AWAIT_AUTOBOOK_CANDIDATE = "Await Autobook - Candidate", r.PRE_PREBRIEF = "Before Prebrief", r.PRE_DEBRIEF = "Before Debrief", r))(t || {}), D = /* @__PURE__ */ ((r) => (r.BEFORE_INTERVIEW = "Before Interview", r))(D || {}), O = /* @__PURE__ */ ((r) => (r.BEFORE_INTERVIEW = "Before Interview", r.AFTER_SCHEDULING_INTERVIEW = "After Scheduling Interview", r))(O || {}), S = /* @__PURE__ */ ((r) => (r.NONE = "None", r.IF_NO_INTERVIEWER_ACCEPTS = "If No Interviewer Accepts", r.IF_CANDIDATE_NOT_ACCEPTED = "If Candidate not yet accepted", r))(S || {}), U = /* @__PURE__ */ ((r) => (r.EVENT = "Event", r.CRON = "Cron", r))(U || {}), s = /* @__PURE__ */ ((r) => (r.ALL_INTERVIEWERS = "All Interviewers", r.ANY_INTERVIEWER = "Any Interviewer", r.CANDIDATE = "Candidate", r))(s || {}), a = /* @__PURE__ */ ((r) => (r.ACCEPT = "accepted", r.DECLINE = "declined", r.TENTATIVE = "tentative", r))(a || {}), T = /* @__PURE__ */ ((r) => (r.CANCEL = "Cancel The Interview", r.SEND_INVITE_TO_CANDIDATE = "Send Invite To The Candidate", r))(T || {});
const j = {
  [I.MIN_0]: 0,
  [I.MIN_5]: 5,
  [I.MIN_10]: 10,
  [I.MIN_15]: 15,
  [I.MIN_30]: 30,
  [I.MIN_45]: 45,
  [I.HOUR_1]: 60,
  [I.HOUR_1_2]: 90,
  [I.HOUR_2]: 120,
  [I.HOUR_3]: 180,
  [I.HOUR_4]: 240,
  [I.HOUR_5]: 300,
  [I.HOUR_6]: 360,
  [I.HOUR_7]: 420,
  [I.HOUR_8]: 480,
  [I.HOUR_9]: 540,
  [I.HOUR_10]: 600,
  [I.HOUR_11]: 660,
  [I.HOUR_12]: 720,
  [I.DAY_1]: 1440,
  [I.DAY_2]: 2880
};
var L = /* @__PURE__ */ ((r) => (r.IN_PROGRESS = "In Progress", r.COMPLETED = "Completed", r.FAILED = "Failed", r))(L || {}), c = /* @__PURE__ */ ((r) => (r[r.free = 0] = "free", r[r.tentative = 1] = "tentative", r[r.busy = 2] = "busy", r[r.ooo = 3] = "ooo", r[r.unknown = 4] = "unknown", r))(c || {}), o = /* @__PURE__ */ ((r) => (r[r.single = 0] = "single", r[r.recurring = 1] = "recurring", r[r.exception = 2] = "exception", r))(o || {}), i = /* @__PURE__ */ ((r) => (r[r.accepted = 0] = "accepted", r[r.tentative = 1] = "tentative", r[r.declined = 2] = "declined", r[r.none = 3] = "none", r))(i || {}), d = /* @__PURE__ */ ((r) => (r[r.private = 0] = "private", r[r.public = 1] = "public", r))(d || {}), v = /* @__PURE__ */ ((r) => (r[r.required = 0] = "required", r[r.optional = 1] = "optional", r[r.resource = 2] = "resource", r[r.organizer = 3] = "organizer", r))(v || {}), H = /* @__PURE__ */ ((r) => (r.EMAIL = "email", r.SMS = "sms", r.MSTEAMS = "msteams", r.SLACK = "slack", r.WHATSAPP = "whatsapp", r))(H || {}), C = /* @__PURE__ */ ((r) => (r.INTERVIEW = "interview", r.AVAILABILITY = "availability", r))(C || {}), l = /* @__PURE__ */ ((r) => (r.ALERTS = "alerts", r.AUTOBOOK = "autobook", r.AUTOMATION = "automation", r.MULTI_DAY_AUTOMATION = "multi-day-automation", r.CONFERENCING = "load-conferencing", r.ENQUEUE_CLOUD_TASK = "enqueue-cloud-task", r.LOCATIONS = "load-locations", r.NOTIFICATIONS = "notifications", r.PRISM = "load-prism", r.ROLES = "load-roles", r.SKILLS = "load-skills", r.USERS = "load-users", r.AUTO_ARCHIVE = "auto-archive", r.ROOSTER_BOT = "roosterbot", r.SERVICE_CENTER_WORKERS = "load-service-center-workers", r))(l || {}), P = /* @__PURE__ */ ((r) => (r.INFO = "info", r.ERROR = "error", r))(P || {}), M = /* @__PURE__ */ ((r) => (r.USER = "user", r.CLIENT = "client", r.SYSTEM = "system", r))(M || {}), B = /* @__PURE__ */ ((r) => (r.CREATE = "create", r.EDIT = "edit", r.DELETE = "delete", r))(B || {}), f = /* @__PURE__ */ ((r) => (r.ENQUEUED = "enqueued", r.PENDING = "pending", r))(f || {}), u = /* @__PURE__ */ ((r) => (r.CREATE = "create", r.UPDATE = "update", r))(u || {}), h = /* @__PURE__ */ ((r) => (r[r.Monday = 1] = "Monday", r[r.Tuesday = 2] = "Tuesday", r[r.Wednesday = 3] = "Wednesday", r[r.Thursday = 4] = "Thursday", r[r.Friday = 5] = "Friday", r[r.Saturday = 6] = "Saturday", r[r.Sunday = 7] = "Sunday", r))(h || {});
const Z = {
  1: "monday",
  2: "tuesday",
  3: "wednesday",
  4: "thursday",
  5: "friday",
  6: "saturday",
  7: "sunday"
}, $ = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday"
];
var F = /* @__PURE__ */ ((r) => (r.EMAIL = "email", r.SMS = "sms", r.MSTEAMS = "msteams", r.SLACK = "slack", r.WHATSAPP = "whatsapp", r))(F || {}), W = /* @__PURE__ */ ((r) => (r.SUCCESS = "success", r.ERROR = "error", r))(W || {}), g = /* @__PURE__ */ ((r) => (r.PENDING = "pending", r.SENT = "sent", r.QUEUED = "queued", r))(g || {}), K = /* @__PURE__ */ ((r) => (r.CREATE = "create", r.EDIT = "edit", r.DELETE = "delete", r))(K || {}), w = /* @__PURE__ */ ((r) => (r.ALERTS = "alerts", r.NOTIFICATIONS = "notifications", r.NOTIFICATIONS_DELETE = "notificationsDelete", r.ENQUEUE_CLOUD_TASK = "enqueueCloudTask", r.ENQUEUE_CLOUD_TASK_FIRESTORE = "enqueueCloudTaskFirestore", r.ENQUEUE_CLOUD_TASK_EDIT = "enqueueCloudTaskEdit", r.ENQUEUE_CLOUD_TASK_DELETE = "enqueueCloudTaskDelete", r.ROOSTER_BOT = "roosterbot", r))(w || {});
const y = {
  "https://graph.microsoft.com": "https://login.microsoftonline.com",
  "https://graph.microsoft.us": "https://login.microsoftonline.us",
  "https://dod-graph.microsoft.us": "https://login.microsoftonline.us",
  "https://graph.microsoft.de": "https://login.microsoftonline.de",
  "https://microsoftgraph.chinacloudapi.cn": "https://login.chinacloudapi.cn"
};
var Y = /* @__PURE__ */ ((r) => (r.GET = "GET", r.DELETE = "DELETE", r.HEAD = "HEAD", r.OPTIONS = "OPTIONS", r.POST = "POST", r.PUT = "PUT", r.PATCH = "PATCH", r))(Y || {}), b = /* @__PURE__ */ ((r) => (r.INTERVIEWER = "interviewer", r.CANDIDATE = "candidate", r))(b || {}), n = /* @__PURE__ */ ((r) => (r[r.isACopyWithoutRespondButton = 0] = "isACopyWithoutRespondButton", r))(n || {}), V = /* @__PURE__ */ ((r) => (r.SCHEDULE = "schedule", r.RESCHEDULE = "reschedule", r.CANCEL = "cancel", r.SUBMIT = "submit", r.UPDATE = "update", r))(V || {});
const p = "__unknown__", m = 1, rr = 1e4, Ir = 5e3, Er = 25, _r = 100, Ar = 1e3, er = "***********", Rr = 25, Nr = 100, tr = 1e3, Dr = {
  options: [
    "workday_refused_not_found",
    "workday_refused_restricted",
    "disposition_predates_application"
  ]
}, E = {
  pre: "pre",
  post: "post",
  preSession: "preSession",
  postSession: "postSession",
  fixed: "fixed",
  interviewerResponse: "interviewerResponse",
  candidateResponse: "candidateResponse",
  candidateAvailability: "candidateAvailability",
  candidateAutobook: "candidateAutobook",
  prePrebrief: "prePrebrief",
  preDebrief: "preDebrief"
}, Or = {
  [E.pre]: "Before Each Interview",
  [E.post]: "After Each Interview",
  [E.preSession]: "Before All Interviews",
  [E.postSession]: "After All Interviews",
  [E.fixed]: "fixed",
  [E.interviewerResponse]: "Await Response - Interviewer",
  [E.candidateResponse]: "Await Response - Candidate",
  [E.candidateAvailability]: "Await Avaiability - Candidate",
  [E.candidateAutobook]: "Await Autobook - Candidate",
  [E.prePrebrief]: "prePrebrief",
  [E.preDebrief]: "preDebrief"
};
var G = /* @__PURE__ */ ((r) => (r.JOB = "job", r.PROSPECT = "prospect", r.MEETING = "meeting", r.BRIEF = "brief", r))(G || {}), k = /* @__PURE__ */ ((r) => (r.EVERYONE = "everyone", r.MINE = "mine", r.ARCHIVED = "archived", r.PROSPECTS = "prospects", r.BOOKINGS = "bookings", r.URGENT = "urgent", r.RECENT = "recent", r.CALENDAR_VIEW = "calendar_view", r.ERROR_EVENTS = "error_events", r.QUICK_INTERVIEWS = "quick_interviews", r.REDACTED = "redacted", r.PROSPECT_LINKS = "prospect_links", r.MEETING_LINKS = "meeting_links", r.MY_PROSPECTS = "my_prospects", r.BRIEFS = "briefs", r.MY_BRIEFS = "my_briefs", r.CONFIDENTIAL = "confidential", r))(k || {}), Q = /* @__PURE__ */ ((r) => (r.AVAILABILITY = "AVAILABILITY", r.AUTOBOOK = "AUTOBOOK", r.ROOSTERLINKS_PROSPECT = "ROOSTERLINKS_PROSPECT", r.ROOSTERLINKS_MEETING = "ROOSTERLINKS_MEETING", r.MANUAL_SCHEDULING = "MANUAL_SCHEDULING", r.WD_INIT_AUTOBOOK = "WD_INIT_AUTOBOOK", r.WD_INIT_AVAILABILITY = "WD_INIT_AVAILABILITY", r.QUICK_INTERVIEW = "QUICK_INTERVIEW", r))(Q || {}), x = /* @__PURE__ */ ((r) => (r.AVAILABILITY_REQUESTED = "availability_requested", r.AVAILABILITY_RECEIVED = "availability_received", r.AUTOBOOK_REQUESTED = "autobook_requested", r.INTERVIEW = "Interview", r))(x || {});
const Sr = "SUPER_ADMIN", _ = "TENANT_ADMIN", A = "SCHEDULING_ADMIN", e = "SCHEDULER", R = "SCHEDULER_ONLY", Ur = "Interviewer", sr = "Candidate", ar = {
  [_]: "Tenant Admin",
  [A]: "Scheduling Admin",
  [e]: "Scheduler",
  [R]: "Scheduler Only"
}, Tr = {
  [_]: 3,
  [A]: 2,
  [e]: 1,
  [R]: 0
};
var X = /* @__PURE__ */ ((r) => (r.Candidate = "Candidate", r.Rooster = "Rooster", r))(X || {}), q = /* @__PURE__ */ ((r) => (r.candidateSelectsAutobook = "candidateSelectsAutobook", r.candidateSelectsAvailability = "candidateSelectsAvailability", r.candidateCancelsAutobook = "candidateCancelsAutobook", r.candidateCancelsAvailability = "candidateCancelsAvailability", r))(q || {}), z = /* @__PURE__ */ ((r) => (r.USER = "user", r.TENANT = "tenant", r.INTERVIEW = "interview", r.RESCHEDULE_INTERVIEW = "reschedule-interview", r))(z || {});
export {
  P as AlertEventType,
  M as AlertTypes,
  G as ApplicationType,
  s as AudienceType,
  a as AutomationAction,
  L as AutomationActionStatus,
  S as AutomationCronCondition,
  O as AutomationCronType,
  T as AutomationTask,
  U as AutomationType,
  Rr as BLOCKED_LIST_DEFAULT_LIMIT,
  Nr as BLOCKED_LIST_MAX_LIMIT,
  tr as BLOCKED_PURGE_MAX_IDS,
  p as BLOCKED_STAGE_UNKNOWN,
  Dr as BlockedReason,
  sr as CANDIDATE,
  H as CHANNELS,
  v as CalendarEventAttendeeEnum,
  o as CalendarEventInstanceEnum,
  i as CalendarEventResponseStatusEnum,
  c as CalendarEventTransparencyEnum,
  d as CalendarEventVisibilityEnum,
  N as CalenderResponseEvents,
  B as CloudTaskOperation,
  f as CloudTaskStatus,
  C as EntityTypeEnum,
  y as GRAPH_URL_TO_AD_ENDPOINT_URL,
  Tr as HIERARCHY,
  u as HandleCloudTaskOperation,
  Y as HttpMethodEnum,
  ar as IAM_ROLES,
  n as IEmailCustomInfoType,
  Ur as INTERVIEWER,
  X as ITermsAndConditionType,
  Q as InterviewRequestSourceEnum,
  J as JOB_APPLICATION_EVENT_TYPE,
  m as MIN_THRESHOLD_MONTHS,
  F as NotificationChannel,
  W as NotificationResponseStatus,
  g as NotificationStatus,
  K as NotificationType,
  V as OperationTypeEnum,
  rr as PURGE_ADHOC_SAVE_HARD_CAP,
  er as PURGE_CONFIDENTIAL_MASK,
  Ir as PURGE_FILTERED_EXPORT_ROW_CAP,
  Ar as PURGE_PREVIEW_COUNT_CAP,
  Er as PURGE_PREVIEW_DEFAULT_LIMIT,
  _r as PURGE_PREVIEW_MAX_LIMIT,
  b as PendingConfirmationParty,
  l as PubsubTopic,
  E as REMINDER_TYPES,
  Or as REMINDER_TYPE_WITH_LABEL_MAP,
  t as ReminderTypeOption,
  x as ReportRequestTypeCodeBackwardCompatEnum,
  e as SCHEDULER,
  R as SCHEDULER_ONLY,
  A as SCHEDULING_ADMIN,
  Sr as SUPER_ADMIN,
  _ as TENANT_ADMIN,
  q as TRIGGER_EVENT_TYPES,
  z as TRIGGER_PARENT_TYPE,
  I as TimeOptions,
  j as TimeOptionsValueMap,
  w as ValidationKeys,
  k as ViewMode,
  h as Weekdays,
  Z as WeekdaysLabelMap,
  $ as WeekdaysLabelsForWorkerPopover,
  D as type2
};
